import { useState } from "react";
import { FmHeaderFilterDateProps } from "domains/file-manager/components/FileManagerV2/FmHeaderFilterDate";

export default function useAssetFilterDate() {
  const [dateRange, setDateRange] = useState<
    FmHeaderFilterDateProps["value"] | undefined
  >();

  return {
    dateQueryArgs: {
      dateRange,
    },
    fmHeaderFilterDateProps: {
      value: dateRange,
      onChange: setDateRange,
    },
  };
}
